"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeFooterLoadingError = removeFooterLoadingError;
exports.removeFooterSavingError = removeFooterSavingError;
exports.fetchCanSpamSettingsIfNotPresent = fetchCanSpamSettingsIfNotPresent;
exports.updateCanSpamSettings = updateCanSpamSettings;
exports.createOrUpdateCanSpamSettings = createOrUpdateCanSpamSettings;
exports.saveChangesToCanSpamSettings = saveChangesToCanSpamSettings;

var _CanSpamSettings = require("lead-flows-ui/selectors/CanSpamSettings");

var _CanSpamSettingsUtils = require("lead-flows-ui/utils/CanSpamSettingsUtils");

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _CanSpamSettingsApiClient = _interopRequireDefault(require("lead-flows-ui/api/CanSpamSettingsApiClient"));

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

function requestCanSpamSettings() {
  return {
    type: _ActionTypes.REQUEST_CAN_SPAM_SETTINGS_FOR_EDITOR
  };
}

function recieveCanSpamSettings(canSpamSettings) {
  return {
    type: _ActionTypes.RECEIVE_CAN_SPAM_SETTINGS_FOR_EDITOR,
    payload: canSpamSettings
  };
}

function errorCanSpamSettings(error) {
  return {
    type: _ActionTypes.ERROR_CAN_SPAM_SETTINGS,
    payload: error,
    error: true
  };
}

function updateEditableCanSpamSettings(update) {
  return {
    type: _ActionTypes.UPDATE_EDITABLE_CAN_SPAM_SETTINGS,
    payload: update
  };
}

function saveCanSpamSettings() {
  return {
    type: _ActionTypes.SAVE_CAN_SPAM_SETTINGS
  };
}

function saveCanSpamSettingsSuccess(canSpamSettings) {
  return {
    type: _ActionTypes.SAVE_CAN_SPAM_SETTINGS_SUCCESS,
    payload: canSpamSettings
  };
}

function saveCanSpamSettingsError(error) {
  return {
    type: _ActionTypes.SAVE_CAN_SPAM_SETTINGS_ERROR,
    payload: error
  };
}

function removeFooterLoadingError() {
  return {
    type: _ActionTypes.REMOVE_CAN_SPAM_SETTINGS_LOADING_ERROR
  };
}

function removeFooterSavingError() {
  return {
    type: _ActionTypes.REMOVE_CAN_SPAM_SETTINGS_SAVE_ERROR
  };
}

function fetchCanSpamSettingsIfNotPresent(portalId) {
  return function (dispatch, getState) {
    var canSpamSettings = (0, _CanSpamSettings.getOriginalCanSpamSettings)(getState());

    if ((0, _CanSpamSettingsUtils.emailFooterIsSetUp)(canSpamSettings)) {
      return dispatch(recieveCanSpamSettings(canSpamSettings));
    }

    dispatch(requestCanSpamSettings());
    return _CanSpamSettingsApiClient.default.fetchCanSpamSettings(portalId).then(function (response) {
      dispatch(recieveCanSpamSettings(response));
    }, function (error) {
      dispatch(errorCanSpamSettings(error.xhr));
    }).done();
  };
}

function updateCanSpamSettings(changes) {
  return function (dispatch) {
    dispatch(updateEditableCanSpamSettings(changes));
  };
}

function createOrUpdateCanSpamSettings(canSpamSettings) {
  return function (dispatch) {
    dispatch(saveCanSpamSettings());
    return _CanSpamSettingsApiClient.default.updateCanSpamSettings(canSpamSettings).then(function (response) {
      dispatch(saveCanSpamSettingsSuccess(response));
      (0, _eventsTrackerUtils.trackEditorInteraction)('can-spam-post');
    }, function (error) {
      dispatch(saveCanSpamSettingsError(error.xhr));
      (0, _eventsTrackerUtils.trackEditorError)('can-spam-post-failure');
    }).done();
  };
}

function saveChangesToCanSpamSettings(callback) {
  return function (dispatch, getState) {
    dispatch(saveCanSpamSettings());
    var canSpamSettings = getState().canSpamSettings.editableCanSpamSettings;
    return _CanSpamSettingsApiClient.default.updateCanSpamSettings(canSpamSettings).then(function (response) {
      dispatch(saveCanSpamSettingsSuccess(response));
      callback();
      (0, _eventsTrackerUtils.trackEditorInteraction)('can-spam-post');
    }, function (error) {
      dispatch(saveCanSpamSettingsError(error.xhr));
      (0, _eventsTrackerUtils.trackEditorError)('can-spam-post-failure');
    }).done();
  };
}